import React, { useState } from "react";
import { MapPin } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { village } from "../mock";
import Lightbox from "./Lightbox";

export default function ForsteVillage() {
  useReveal();
  const [active, setActive] = useState(null);
  if (!village) return null;

  return (
    <section id="village" className="bg-ink py-24 sm:py-36 border-t border-[var(--c-border)]">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6 text-gold">
            <MapPin className="w-4 h-4" />
            <span className="eyebrow" data-testid="village-eyebrow">{village.eyebrow}</span>
          </div>
          <h2 className="font-display text-4xl sm:text-6xl font-light leading-[1.02] text-parchment">
            {village.title}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-parchment/60 font-light">{village.intro}</p>
        </div>

        <figure
          data-testid="village-lead"
          className="img-zoom border border-[var(--c-border)] bg-ink2 cursor-pointer mt-12"
          onClick={() => setActive(village.lead)}
        >
          <img src={village.lead.src} alt={village.lead.caption} className="w-full h-72 sm:h-[32rem] object-cover" />
          <figcaption className="px-6 py-4 border-t border-[var(--c-border)]">
            <p className="font-display italic text-lg sm:text-xl text-parchment/85 leading-snug">{village.lead.caption}</p>
          </figcaption>
        </figure>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          {village.images.map((img, i) => (
            <figure
              key={i}
              data-testid={`village-image-${i}`}
              className="reveal img-zoom relative border border-[var(--c-border)] bg-ink2 cursor-pointer"
              style={{ animationDelay: `${(i % 3) * 90}ms` }}
              onClick={() => setActive(img)}
            >
              <img src={img.src} alt={img.caption} className="w-full h-56 object-cover" />
              <figcaption className="px-5 py-4 border-t border-[var(--c-border)]">
                <p className="font-display italic text-parchment/85 leading-snug">{img.caption}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      <Lightbox src={active?.src} caption={active?.caption} onClose={() => setActive(null)} />
    </section>
  );
}
